import React from 'react'
import { Box } from '@mui/material'
import AdapterCard from './AdapterCard'
import { useGetSamlProvidersQuery } from '../../../../api/settings.api'
import { useActivateSamlProviderMutation, useDeactivateSamlProviderMutation } from '../../../../api/settings.api'

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginTop: 2,
    marginBottom: 2
  }
}

export default function AdapterCardList({ onConfigure }) {
  const { data: adapters = [] } = useGetSamlProvidersQuery()
  const [activateProvider] = useActivateSamlProviderMutation()
  const [deactivateProvider] = useDeactivateSamlProviderMutation()

  const handleActivate = async id => {
    try {
      await activateProvider(id).unwrap()
    } catch (error) {
      console.error('Failed to activate provider:', error)
    }
  }

  const handleDeactivate = async id => {
    try {
      await deactivateProvider(id).unwrap()
    } catch (error) {
      console.error('Failed to deactivate provider:', error)
    }
  }

  return (
    <Box sx={styles.container}>
      {adapters.map(adapter => (
        <AdapterCard
          key={adapter.id}
          adapter={adapter}
          onConfigure={onConfigure}
          onActivate={handleActivate}
          onDeactivate={handleDeactivate}
        />
      ))}
    </Box>
  )
}
